import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, CommercialService, LoadingService, UserService } from '@core/services';

import { fadeAnimation } from '../../app.animations';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatTooltip } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-account-summary',
  templateUrl: './account-summary.component.html',
  styleUrls: ['./account-summary.component.css'],
  animations: [fadeAnimation]
})

export class AccountSummaryComponent implements OnInit, OnDestroy {

  user: any;
  userName: string;
  subscription: Subscription;
  promo_trips: number = 0;
  referForm: FormGroup;
  referralProcessing: boolean = false;
  isLoading: boolean = false;
  referralButtonClicked: boolean = false;
  @ViewChild('tooltip') tooltip:MatTooltip;
  public isCommercialCustomer = false;
  uniqueCode: string;

  constructor(private _userService: UserService, public _authGuard: AuthGuardService, private router: Router,private _fb: FormBuilder,private dialog: MatDialog, private _loadingService: LoadingService,private _commercialService: CommercialService, private location: LocationStrategy) {
  }

  ngOnInit() {
    history.pushState(null, null, window.location.href);
    // check if back or forward button is pressed.
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
  });
    this.subscription = this._userService.getUser()
      .subscribe(user => {
        this.user = user
        console.log(this.user);
        if (this.user && this.user.accountSummaryArray && this.user.accountSummaryArray.length > 0) {
          this.promo_trips = 0;
          for (var accountSummary of this.user.accountSummaryArray) {
            console.log("Promo trips:", accountSummary["PromoTrips"])
            this.promo_trips += parseInt(accountSummary["PromoTrips"]);
          }
        }
        if (this.user.customerIdArray[this.user.customerIndex] && this.user.customerIdArray[this.user.customerIndex].Account) {
          this.uniqueCode = this.user.customerIdArray[this.user.customerIndex].Id.toString().padStart(5,'0') + this.user.customerIdArray[this.user.customerIndex].Account.Id.toString().padStart(5,'0');
         }   
      });

     if (this.user.customerIdArray.length > 0) {
       this._authGuard.getAccountInfo();
       this._authGuard.getCreditCards();
    }


    this.referForm = this._fb.group({
      email: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
    });

    this.referForm.valueChanges.subscribe((changes: any) => {
      this.referralProcessing = this.referForm.valid && this.referralButtonClicked;
      this.isLoading = this.referForm.valid && this.referralButtonClicked;
    });
    
    this._commercialService.getCommercialValue().subscribe(isCommercial => {
      this.isCommercialCustomer = isCommercial.isCustomerCommercial;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  updateAccountArray(event) {
    this._authGuard.getAccountInfo();
  }

  submitInvite(){
    this.referralButtonClicked = true;
    var data =  {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      AccountId: this.user.customerIdArray[this.user.customerIndex].Account.Id,
      Email: this.referForm.controls.email.value
    }


    const referralUrl = 'portfolios/ReferFriend';

    this._authGuard.authenticatedPost(referralUrl, data).subscribe(
      result => {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: "Your email invitation has been sent",
            alertType: "success",
            title: "Invite Sent Successfully",
          },
        });
        this.referForm.controls.email.reset();
        this.referralButtonClicked = false;
      },
      error => {
        console.log('Error: ' + error);
        if (error && error.toString().includes("Daily Referral Limit")){
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: "Your invitation could not be sent. " + error.toString(),
              alertType: "danger",
              title: "Invite Not Sent",
            },
          });
        } else {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              message: "Your invitation could not be sent",
              alertType: "danger",
              title: "Invite Not Sent",
            },
          });
        }
        this.referForm.controls.email.reset();
        this.referralButtonClicked = false;
      }
    );
    //this.referralButtonClicked = false;
    //this._loadingService.hideLoader();
  }


  copyMessage(){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = "https://nexpress.dwtunnel.com/registration?referralCode=" + this.user.customerIdArray[this.user.customerIndex].Id.toString().padStart(5,'0') + this.user.customerIdArray[this.user.customerIndex].Account.Id.toString().padStart(5,'0');
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    //this.toolTip.show()
    this.tooltip.hide();
    setTimeout(()=> {
      this.tooltip.message = 'Copied!'
      this.tooltip.show();
    },500)
    document.body.removeChild(selBox);
    setTimeout(()=> {
      this.tooltip.message = "Copy Invite Link";
      this.tooltip.hide();
    },4000)
  }

  moneyFormat(balance: number){
    return balance.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
  }

  navigate(id, index){
    this._userService.setAccountIndex(index);
    this.router.navigate(['accountdetail', id]);
  }

  updateAccountPassArray(event) {
    //this.getAccountPasses();
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/account-summary/account-summary.component.ts